"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _FunctionOutlined = _interopRequireDefault(require("@ant-design/icons-svg/lib/asn/FunctionOutlined"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var FunctionOutlined = function FunctionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _FunctionOutlined.default
  }));
};

/**![function](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik04NDEgMzcwYzMtMy4zIDIuNy04LjMtLjYtMTEuM2E4LjI0IDguMjQgMCAwMC01LjMtMi4xaC03Mi42Yy0yLjQgMC00LjYgMS02LjEgMi44TDYzMy41IDUwNC42YTcuOTYgNy45NiAwIDAxLTEzLjQtMS45bC02My41LTE0MS4zYTcuOSA3LjkgMCAwMC03LjMtNC43SDM4MC43bC45LTQuNyA4LTQyLjNjMTAuNS01NS40IDM4LTgxLjQgODUuOC04MS40IDE4LjYgMCAzNS41IDEuNyA0OC44IDQuN2wxNC4xLTY2LjhjLTIyLjYtNC43LTM1LjItNi4xLTU0LjktNi4xLTEwMy4zIDAtMTU2LjQgNDQuMy0xNzUuOSAxNDcuM2wtOS40IDQ5LjRoLTk3LjZjLTMuOCAwLTcuMSAyLjctNy44IDYuNEwxODEuOSA0MTVhOC4wNyA4LjA3IDAgMDA3LjggOS43SDI4NGwtODkgNDI5LjlhOC4wNyA4LjA3IDAgMDA3LjggOS43SDI2OWMzLjggMCA3LjEtMi43IDcuOC02LjRsODkuNy00MzMuMWgxMzUuOGw2OC4yIDEzOS4xYzEuNCAyLjkgMSA2LjQtMS4yIDguOGwtMTgwLjYgMjAzYy0yLjkgMy4zLTIuNiA4LjQuNyAxMS4zIDEuNSAxLjMgMy40IDIgNS4zIDJoNzIuN2MyLjQgMCA0LjYtMSA2LjEtMi44bDEyMy43LTE0Ni43YzIuOC0zLjQgNy45LTMuOCAxMS4zLTEgLjkuOCAxLjYgMS43IDIuMSAyLjhMNjc2LjQgNzg0YzEuMyAyLjggNC4xIDQuNyA3LjMgNC43aDY0LjZhOC4wMiA4LjAyIDAgMDA3LjItMTEuNWwtOTUuMi0xOTguOWMtMS40LTIuOS0uOS02LjQgMS4zLTguOEw4NDEgMzcweiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/React.forwardRef(FunctionOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FunctionOutlined';
}
var _default = exports.default = RefIcon;